export default {
  setLoaded(state, loaded) {
    state.loaded = loaded
  },
  setNominees(state, nominees) {
    state.nominees = nominees
  },
  setCategories(state, categories) {
    state.categories = categories
  },
  setRounds(state, rounds) {
    state.rounds = rounds
  },
  selectNominee(state, { categoryId, nomineeId }) {
    const cleared = state.selected.filter((choice) => !(choice.categoryId === categoryId))

    state.selected = cleared.concat([{ categoryId, nomineeId }])
  },
  addSuggestion(state, { categoryId, suggestionName }) {
    const cleared = state.selected.filter((choice) => !(choice.categoryId === categoryId))
    state.selected = cleared.concat([{ categoryId, suggestionName }])
    state.suggestions.push({ suggestionName, categoryId })
  },
  clearCategory(state, { categoryId }) {
    state.selected = state.selected.filter((choice) => !(choice.categoryId === categoryId))
  },
  clearSelected(state) {
    state.selected = []
  },
  setSelectedChannelId(state, { categoryId, tagId }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.selectedChannelId = category.selectedChannelId === tagId ? null : tagId
  },
  setSelectedDayPartId(state, { categoryId, tagId }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.selectedDayPartId = category.selectedDayPartId === tagId ? null : tagId
  },
  setKeyword(state, { categoryId, keyword }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.keyword = keyword
  },
  setSortType(state, { categoryId, sortType }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.sortType = sortType
  },
  setAllowSuggestions(state, allowSuggestions) {
    state.allowSuggestions = allowSuggestions
  },
  setFailedFetch(state) {
    state.failedFetch = true
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js